import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import PurchasePresentTypeModalPage from '../../../containers/masters/PurchasePresentTypeModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class PurchasePresentTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchName: null,
        searchDescription: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchPurchasePresentTypeList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchPurchasePresentTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchPurchasePresentTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleDescriptionChange (searchDescription) {
    if (this.state.filter.searchDescription !== searchDescription) {
      this.setState({ filter: { ...this.state.filter, searchDescription } })
    }
  }

  searchPurchasePresentTypeList () {
    this.props.actions.fetchPurchasePresentTypeList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchName: null,
        searchDescription: null
      }
    }, () => { this.searchPurchasePresentTypeList() })
  }

  render () {
    const {
      t, purchasePresentTypeMastersList, pagesCount, purchasePresentCount, filter,
      filter: { page },
      actions: { deletePurchasePresentTypeModal, openPurchasePresentTypeModal, recoverPurchasePresentTypeModal, fetchPurchasePresentTypeList }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'purchasePresentTypeMastersPage' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.searchDescription || this.state.filter.searchName)

    return (
      <div id='purchasePresentTypeMasters' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openPurchasePresentTypeModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchPurchasePresentTypeList()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="iDocIcon-search"/>
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(purchasePresentTypeMastersList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('uo') }}>
                        {t('MASTERS.PURCHASE_PRESENT_TYPE_MASTERS.ORGANIZED_UNIT')}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th style={{ width: '77px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchasePresentTypeMastersList && purchasePresentTypeMastersList.map((purchasePresentTypeMaster, idx) => (
                      <tr key={idx} className={purchasePresentTypeMaster.isDeleted ? 'is-deleted' : ''}>
                        <td>{purchasePresentTypeMaster.organizedUnitName}</td>
                        <td>{purchasePresentTypeMaster.name}</td>
                        <td>{purchasePresentTypeMaster.description}</td>
                        <td>
                          {!purchasePresentTypeMaster.isDeleted ? (
                            <div>
                              <a onClick={() => openPurchasePresentTypeModal(this.state.uoId, purchasePresentTypeMaster.purchasePresentTypeId)}>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <i className="ico-edit-white" />
                                </OverlayTrigger>
                              </a>
                              <a onClick={() => deletePurchasePresentTypeModal(this.state.uoId, purchasePresentTypeMaster.purchasePresentTypeId)}>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <i className="ico-trash" />
                                </OverlayTrigger>
                              </a>
                            </div>
                          ) : (
                            <a onClick={() => recoverPurchasePresentTypeModal(this.state.uoId, purchasePresentTypeMaster.purchasePresentTypeId)}>
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <Glyphicon glyph="repeat" />
                              </OverlayTrigger>
                            </a>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }
              {(purchasePresentTypeMastersList === null || purchasePresentTypeMastersList === undefined || purchasePresentTypeMastersList.length === 0) &&
                <p className="no_results" >{t(`${tKey}PURCHASE_PRESENT_TYPE_MASTERS.RESULTS_NOT_FOUND`)}</p>}
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_finance"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={purchasePresentCount}
                    onSelectAction={(value) => fetchPurchasePresentTypeList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <PurchasePresentTypeModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listPurchasePresentType'
})(PurchasePresentTypeMaster)
